import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import { toast } from "react-toastify";
import { Calendar } from "primereact/calendar";
import storage from "../../../Services/Storage";
import Axios from "../../../api/Axios";
import { GetDateFormat } from "../../../Services/GlobalFunc/DateFormat";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";

const GRNDiscountDatatoExcel = () => {
    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const [loadingExcel, setLoadingExcel] = useState(false);

    const reportApi = "Reports/GRNDscntDataDwnld?";

    // api/

    const handleExportExcel = async () => {
        const fDate = new Date(fromDate);
        const fromDateRange = format(fDate, "dd/MM/yyyy");
        const tDate = new Date(toDate);
        const toDateRange = format(tDate, "dd/MM/yyyy");
        try {
            setLoadingExcel(true);
            const InvrptApi = `${reportApi}CompId=${auth.CompId}&FromDate=${fromDateRange}&ToDate=${toDateRange}`;
            let dataresponse = await Axios.get(InvrptApi);
            let uniqueNo = `GRNDiscountData${GetDateFormat()}.xlsx`;
            if (dataresponse?.data?.length == 0) {
                toast.warning("No data found between these dates", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setLoadingExcel(false);
            } else {
                downloadExcel(dataresponse.data, uniqueNo);
                setLoadingExcel(false);
            }
        } catch (error) {
            setLoadingExcel(false);
            console.log(error);
        }
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <h3 className="py-2">GRN Discount Data to Excels</h3>
            <section className="sales-box">
                <form>
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">From Date</label>
                            <Calendar
                                onChange={(e) => setFromDate(e.value)}
                                showIcon
                                value={fromDate}
                                min="2010-01-01"
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <label className="form-label">To Date</label>
                            <Calendar
                                value={toDate}
                                onChange={(e) => setToDate(e.value)}
                                showIcon
                                dateFormat="dd/mm/yy"
                                showMinMaxRange={true}
                            />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleExportExcel}
                                    disabled={loadingExcel}
                                >
                                    {loadingExcel ? "Loading..." : "Save as Excel"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );
};

export default GRNDiscountDatatoExcel;
